import { Controller } from "stimulus"
import * as echarts from "echarts"

export default class extends Controller {
  connect() {
    const options = this.element.dataset.chartsOptionsValue

    if (!options) {
      return
    }

    try {
      const chartOptions = JSON.parse(options)
      this.chart = echarts.init(this.element)
      this.chart.setOption(chartOptions)

    } catch (error) {
    }
  }

  resize = () => {
    if (this.chart) this.chart.resize()
  }

  disconnect() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  }
}
